// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth,GoogleAuthProvider}  from "firebase/auth";
import {getFirestore} from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDFJ_3D0I1IuhO-XMSvmimgQOu_794Blbg",
    authDomain: "react-app-5d5b7.firebaseapp.com",
    projectId: "react-app-5d5b7",
    storageBucket: "react-app-5d5b7.appspot.com",
    messagingSenderId: "354616515261",
    appId: "1:354616515261:web:4982db76cb36582b5ef5d4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);